import React from 'react'
import logo from "../containers/assets/images/logo.PNG";

const Sources = () => {
  return (
    <>
    <div className="h-full w-full mx-auto mt-10 relative 3xl:left-[400px] 3xl:-top-[500px] 2xl:-top-[350px] 2xl:left-[200px]  sm:-top-[220px] md:-top-[320px] lg:-top-[300px] -mb-72">
          <div className="" data-aos="zoom-in-down" data-aos-duration="2000">
            <div className="flex flex-wrap h-[1250px] 3xl:w-[1300px] 3xl:h-[600px] 2xl:w-[900px] 2xl:h-[400px] xl:w-[1100px] sx:h-[600px] xm:h-[1200px] lg:h-[600px] mx-auto my-5 p-10 shadow-lg rounded-md">
              <div className="flex flex-col justify-evenly h-[230px] w-[250px] xm:w-[500px] md:w-[750px] lg:w-[450px] 2xl:w-[400px] 2xl:h-[150px] 3xl:w-[600px] 3xl:h-[250px]  border-5 mt-5 2xl:my-auto bg-slate-100 opacity-75 mx-auto rounded z-20 shadow-md">
                <p className="text-zinc-600 2xl:text-base text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-12">
                  Trésorerie
                </p>
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl  font-bold"
                  data-aos="zoom-in"
                  data-aos-delay="1200"
                  data-aos-duration="500"
                >
                  Fournisseurs
                </p>
                <p
                  className="text-blue-900 2xl:text-base text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos="zoom-in"
                  data-aos-delay="500"
                  data-aos-duration="400"
                >
                  Clients
                </p>
                <p
                  className="text-zinc-600 2xl:text-base  text-xl xm:text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-16"
                  data-aos="zoom-in"
                  data-aos-delay="1500"
                  data-aos-duration="500"
                >
                  Financement
                </p>
              </div>
              <div className="flex flex-col justify-evenly h-[230px] w-[250px] xm:w-[500px] md:w-[750px] lg:w-[450px] 2xl:w-[400px] 2xl:h-[150px] 3xl:w-[600px] 3xl:h-[250px] border-5 mt-5 2xl:my-auto bg-slate-100 opacity-75 mx-auto rounded z-20 shadow-md">
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos="zoom-in"
                  data-aos-delay="900"
                  data-aos-duration="500"
                >
                  Achats
                </p>
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl  font-bold"
                  data-aos="zoom-in"
                  data-aos-delay="1300"
                  data-aos-duration="500"
                >
                  Stocks
                </p>
                <p
                  className="text-blue-900 2xl:text-base text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-16"
                  data-aos="zoom-in"
                  data-aos-delay="600"
                  data-aos-duration="500"
                >
                  Charges
                </p>
                <p
                  className="text-zinc-600 2xl:text-base text-xl xm:text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos="zoom-in"
                  data-aos-delay="1600"
                  data-aos-duration="500"
                >
                  Délais de Rotation
                </p>
              </div>
              <div className="flex flex-col justify-evenly h-[230px] w-[250px] xm:w-[500px] md:w-[750px] lg:w-[450px] 2xl:w-[400px] 2xl:h-[150px] 3xl:w-[600px] 3xl:h-[250px] border-5 mt-5 2xl:my-auto bg-slate-100 opacity-75 mx-auto rounded z-20 shadow-md">
                <p
                  className="text-zinc-600 2xl:text-base text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-16"
                  data-aos="zoom-in"
                  data-aos-delay="1000"
                  data-aos-duration="500"
                >
                  CA
                </p>
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl  font-bold"
                  data-aos="zoom-in"
                  data-aos-delay="1400"
                  data-aos-duration="500"
                >
                  Marge
                </p>
                <p
                  className="text-blue-900 2xl:text-base text-2xl 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos="zoom-in"
                  data-aos-delay="700"
                  data-aos-duration="500"
                >
                  Résultats
                </p>
                <p
                  className="text-zinc-600 xm:text-2xl 2xl:text-base 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-16"
                  data-aos="zoom-in"
                  data-aos-delay="1700"
                  data-aos-duration="500"
                >
                  Part de marché
                </p>
              </div>
              <div className="flex flex-col justify-evenly h-[230px] w-[250px] xm:w-[500px] md:w-[750px] lg:w-[450px] 2xl:w-[400px] 2xl:h-[150px] 3xl:w-[600px] 3xl:h-[250px] border-5 mt-5 2xl:my-auto bg-slate-100 opacity-75 mx-auto rounded z-20 backdrop-blur/10 shadow-md">
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos="zoom-in"
                  data-aos-delay="1100"
                  data-aos-duration="500"
                >
                  Frais
                </p>
                <p
                  className="text-zinc-600 text-2xl 2xl:text-base 3xl:text-2xl  font-bold"
                  data-aos="zoom-in"
                  data-aos-delay="1500"
                  data-aos-duration="500"
                >
                  Salaires
                </p>
                <p
                  className="text-blue-900 text-2xl 2xl:text-base 3xl:text-2xl font-bold xm:flex xm:justify-end xm:mr-16"
                  data-aos="zoom-in"
                  data-aos-delay="800"
                  data-aos-duration="500"
                >
                  Social
                </p>
                <p
                  className="text-zinc-600 xm:text-2xl 2xl:text-base 3xl:text-2xl font-bold xm:flex xm:justify-start xm:ml-16"
                  data-aos-delay="1800"
                  data-aos-duration="500"
                >
                  Turn-Over
                </p>
              </div>
              <img
                alt="logo"
                src={logo}
                className=" collapse xl:visible z-30 w-[100px] h-[100px] absolute lg:ml-[460px] lg:mt-[210px] 2xl:ml-[375px] 2xl:mt-[130px] 2xl:w-[70px] 2xl:h-[70px] 3xl:mt-[225px] 3xl:ml-[575px] rounded-lg opacity-70"
              />
            </div>
          </div>
        </div>
    </>
  )
}

export default Sources